import React from 'react';
var battleFeedbackContext = React.createContext({
    previewEnabled: false
});
battleFeedbackContext.displayName = 'BattleFeedbackContext';
export var BattleFeedbackContextProvider = battleFeedbackContext.Provider;
export var useBattleFeedbackContext = function () { return React.useContext(battleFeedbackContext); };
